<div class="row tp-timeline-slider">
    <div class="col-12">
        <div class="row mb-3">
            <div class="col-4 d-flex flex-wrap flex-column justify-content-center my-4">
                <h5 class="fw-bold">{{ "national_projects.overall_progress" | translate }}</h5>
                <h6 class="fw-bold text-primary">{{ project() | translateToken: "entityName" }}</h6>
            </div>
            <div class="col-2 pt-4 text-center">
                <adaa-progress-number
                    [value]="project().progress"
                    [fillColor]="Constants.COLOR_CODES[project().onTimeProgressColor]"
                    size="md"
                    label="common.tables.progress"
                />
            </div>
            <div class="col-sm-6 col-xs-12">
                <adaa-timeline-bar
                    variant="planned"
                    [title]="getTitle(range().start, range().end)"
                    [rangeStart]="range().start"
                    [rangeEnd]="range().end"
                    [start]="range().start"
                    [end]="range().end"
                />
                <adaa-timeline-bar
                    variant="actual"
                    [title]="getTitle(project().actualStartDate, project().actualEndDate, true)"
                    [rangeStart]="range().start"
                    [rangeEnd]="range().end"
                    [start]="project().actualStartDate"
                    [end]="project().actualEndDate"
                />
            </div>
            <div class="col-12 d-flex flex-wrap justify-content-end align-items-center">
                <span class="text-muted mx-1">
                    <fa-icon class="text-secondary" [icon]="['fas', 'circle']"></fa-icon>
                    {{ "national_projects.planned" | translate }}
                </span>
                <span class="text-muted mx-1">
                    <fa-icon class="text-primary" [icon]="['fas', 'circle']"></fa-icon>
                    {{ "national_projects.actual" | translate }}
                </span>
            </div>
        </div>
        <h5 class="bars-title fw-bolder">
            <span>
                {{ milestonesTitle() | translate }}
            </span>
        </h5>
        @for (milestone of milestones(); track milestone; let i = $index) {
            <div class="row mb-3">
                <div class="col-4 d-flex flex-column flex-wrap my-4">
                    <h6 class="fw-bold pointer" (click)="milestoneClicked.emit(milestone)">
                        <span class="badge rounded-pill bg-primary text-white shadow-sm mx-1">{{ i + 1 }} </span>
                        {{ milestone | translateToken: "name" }}
                    </h6>
                    <h6 class="fw-bold text-primary">
                        {{ milestone | translateToken: "entityName" }}

                        <button
                            class="text-info border-0 bg-transparent fs-5"
                            [title]="'national_projects.comments' | translate"
                            (click)="mainAchievementsClicked.emit(milestone)"
                        >
                            <fa-icon [icon]="['fas', 'timeline']"></fa-icon>
                        </button>
                    </h6>
                </div>
                <div class="col-2 pt-4 text-center">
                    <adaa-progress-number
                        [value]="milestone.progress ?? 0"
                        [fillColor]="Constants.COLOR_CODES[milestone.onTimeProgressColor ?? 0]"
                        size="md"
                    />
                </div>
                <div class="col-sm-6 col-xs-12">
                    <adaa-timeline-bar
                        variant="planned"
                        [title]="getTitle(milestone[dateProps().startDate], milestone[dateProps().endDate])"
                        [rangeStart]="range().start"
                        [rangeEnd]="range().end"
                        [start]="milestone[dateProps().startDate]"
                        [end]="milestone[dateProps().endDate]"
                    />
                    <adaa-timeline-bar
                        variant="actual"
                        [title]="getTitle(milestone.actualStartDate, milestone.actualEndDate, true)"
                        [rangeStart]="range().start"
                        [rangeEnd]="range().end"
                        [start]="milestone.actualStartDate"
                        [end]="milestone.actualEndDate"
                    />
                </div>
            </div>
        }
    </div>
</div>
